/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

var EVENT_CODE = /* @__PURE__ */function (EVENT_CODE2) {
  EVENT_CODE2["left"] = "ArrowLeft";
  EVENT_CODE2["up"] = "ArrowUp";
  EVENT_CODE2["right"] = "ArrowRight";
  EVENT_CODE2["down"] = "ArrowDown";
  EVENT_CODE2["esc"] = "Escape";
  return EVENT_CODE2;
}(EVENT_CODE || {});

export { EVENT_CODE };
//# sourceMappingURL=const.mjs.map
